"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IVaultController__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "DepositForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "EmergencyWithdrawnFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "InitializedAlready",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "decimals",
                type: "uint8",
            },
        ],
        name: "InvalidDecimals",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "InvalidDepositTimeRange",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
        ],
        name: "InvalidStableCoin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
        ],
        name: "InvalidWithdrawableTime",
        type: "error",
    },
    {
        inputs: [],
        name: "MoveForbidden",
        type: "error",
    },
    {
        inputs: [],
        name: "MovedAlready",
        type: "error",
    },
    {
        inputs: [],
        name: "NoReward",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
        ],
        name: "NonexistentStableCoin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "currentTime",
                type: "uint256",
            },
        ],
        name: "NotInDepositPeriod",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "currentTime",
                type: "uint256",
            },
        ],
        name: "NotInWithdrawPeriod",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitialized",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyFactory",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferForbidden",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "decimals",
                type: "uint256",
            },
        ],
        name: "CoinAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract IERC20",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "EmergencyWithdrawn",
        type: "event",
    },
];
class IVaultController__factory {
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.IVaultController__factory = IVaultController__factory;
